import { IDashRegistrationForTransplantedList } from '@nkr/store/index';

export interface IDashOption extends IDashRegistrationForTransplantedList {
    label: string
}